import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";
import PhoneNumberField from "../../fields/phoneNumberField";
import { PhoneDefaultValueType } from "../../fields/phoneNumberField/type";

export default function PhoneNumberFieldWrapper(props: DynamicFieldConfigType) {
  return (
    <React.Fragment>
      <PhoneNumberField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        placeholder={props.schemaObj.placeholderLabel}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
        defaultValue={props.schemaObj.defaultValue as PhoneDefaultValueType}
      />
    </React.Fragment>
  );
}
